import { useContext } from "react";

import { LangProviderContext } from "../providers/lang-provider";
import { LocalizedStrings, SupportedLanguages, TextApi } from "../utils/lang";

export default function useText<Source>(
  source: LocalizedStrings<Source>
): TextApi<Source> {
  const { lang } = useContext(LangProviderContext);

  return {
    strings: source[(lang as SupportedLanguages) || SupportedLanguages.DEFAULT],
    activeLanguage: (lang as SupportedLanguages) || SupportedLanguages.DEFAULT,
  };
}
